import { createUseStyles } from 'react-jss'
import { WHITE_23, WHITE, BLUE, BLUE_25, DARK_GRAY_11, DARK_GRAY_05 } from '@omnilert/components'

export default createUseStyles({
  bubble: {
    backgroundColor: ({ isMe }) => isMe ? BLUE : 'var(--primary__page__background)',
    borderBottomLeftRadius: ({ isMe }) => isMe ? 20 : 0,
    borderBottomRightRadius: ({ isMe }) => isMe ? 0 : 20,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    boxShadow: ({ isMe }) => isMe
      ? [
        `0px 4px 15px ${BLUE_25}`,
        `0px 2px 4px ${DARK_GRAY_11}`,
        `inset 0px -2px 0px ${WHITE_23}`
      ] : [
        '0px 4px 15px var(--chat-bubble__box-shadow__color)',
        `0px 2px 4px ${DARK_GRAY_05}`
      ],
    color: ({ isMe }) => isMe ? WHITE : 'var(--chat-bubble__text__color)',
    flexDirection: 'column',
    padding: '.75em',
    whiteSpace: 'pre-line',
    wordBreak: 'break-word',
    lineHeight: '22px',
    display: 'flex',
    '&:hover': {
      cursor: ({ message }) => message?.image ? 'pointer' : 'default'
    }
  }
})
